<h4 class="mb-3">Select Schedule Date & Time</h4>

<mat-dialog-content>
  <mat-form-field appearance="fill" class="large-input">
    <mat-label>Date</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="date" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="fill" class="large-input">
    <mat-label>Time</mat-label>
    <input matInput type="time" [(ngModel)]="time" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()" [disabled]="!date || !time">
    Confirm
  </button>
</mat-dialog-actions>
